import React from 'react';

import { SCCUniversalDevice } from '@/comp/StationControlCenter/types/universal-device.types';

import { useTranslation } from 'react-i18next';
import { useMeasurement } from '@/hooks/useMeasurement';
import { CompressorActivityStateEnum } from '@/constants/enums';

import DetailsWidgetSlider from '../../../../ControlCenterCompressorWidget/DetailsWidgetSlider/DetailsWidgetSlider';
import { getLabelByKey, getSliderPointsFromMetric } from '../../../UniversalDeviceWidget.utils';
import { ContentWithSliderContainer } from './ContentWithSlider.styles';

interface ContentWithSliderProps {
  device: SCCUniversalDevice;
}

export const ContentWithSlider = ({ device }: ContentWithSliderProps) => {
  const { t } = useTranslation();
  const { tunit, tvalue } = useMeasurement();
  const sliderMetric = device.realtimeMetrics?.find((metric) => metric.type === 'slider');
  if (!sliderMetric) return null;

  const sliderPoints = getSliderPointsFromMetric({ metric: sliderMetric, t, tvalue });

  const sliderTitle =
    sliderMetric.type === 'slider' && !sliderMetric.additionalContext?.target ? t(getLabelByKey(sliderMetric.key)) : '';

  return (
    <ContentWithSliderContainer
      className="middle-row">
      <DetailsWidgetSlider
        isInMaintenance={device.inMaintenance}
        title={sliderTitle}
        value={tvalue(Number(sliderMetric.value), sliderMetric.unit)}
        unit={t(tunit(sliderMetric.unit))}
        min={
          sliderMetric.additionalContext?.min?.value !== undefined
            ? tvalue(sliderMetric.additionalContext.min.value, sliderMetric.unit)
            : undefined
        }
        max={
          sliderMetric.additionalContext?.max?.value !== undefined
            ? tvalue(sliderMetric.additionalContext.max.value, sliderMetric.unit)
            : undefined
        }
        points={sliderPoints}
        connectivity={device.connectivity}
        highlightSlider={device.activity?.toLowerCase() === CompressorActivityStateEnum.Load}
        addSideGaps
        hasTarget={sliderMetric.additionalContext?.target !== undefined}
        deviceType={device.deviceType}
      />
    </ContentWithSliderContainer>
  );
};

